import i18n from '@/lang';

/**
 * 认证辅助工具
 * 统一处理 401 错误和登录相关逻辑
 */

// 公开页面列表（不需要登录即可访问）
const PUBLIC_PATHS = ['/', '/quotes', '/rank', '/login', '/register', '/about', '/help', '/categories', '/content'];

/**
 * 检查当前路径是否为公开页面
 * @param {string} path - 路由路径
 * @returns {boolean} 是否为公开页面
 */
export function isPublicPath(path) {
    if (!path) return false;
    // 移除 hash 前缀（如果使用 hash 路由）
    const cleanPath = path.replace(/^#/, '').split('?')[0];
    return PUBLIC_PATHS.includes(cleanPath);
}

/**
 * 处理 401 未授权错误
 * @param {string} currentPath - 当前路由路径
 * @param {Function} triggerLoginCallback - 触发登录提示的回调函数（可选）
 * @returns {boolean} 是否应该静默处理（在公开页面返回 true）
 */
export function handle401Error(currentPath, triggerLoginCallback) {
    const path = currentPath || (typeof window !== 'undefined' ? window.location.pathname : '');
    
    if (isPublicPath(path)) {
        // 在公开页面，静默处理 401 错误
        return true;
    }
    
    // 在需要登录的页面，触发登录提示
    if (typeof triggerLoginCallback === 'function') {
        triggerLoginCallback();
    } else if (typeof window !== 'undefined' && window.triggerLoginRequired) {
        window.triggerLoginRequired();
    }
    
    return false;
}

/**
 * 创建 401 错误响应对象（用于在公开页面静默处理）
 * @returns {Object} 401 错误响应对象
 */
export function create401Response() {
    return {
        code: 401,
        message: i18n.global.t('common.user_not_logged_in'),
        data: null
    };
}

